import {create} from 'zustand';
import type {BookingPassReservation} from '@chekin/shared/guest-form';

const HANDOFF_OPEN_MS = 900;

type FoundReservation = BookingPassReservation & {
  id: string;
  signup_form_link: string;
};

type BookingFoundHandoff = {
  reservation: FoundReservation;
  guestName?: string;
  propertyName?: string;
  isNew?: boolean;
  startedAt: number;
};

type BookingFoundHandoffStore = {
  handoff?: BookingFoundHandoff;
  open: (handoff: Omit<BookingFoundHandoff, 'startedAt'>) => void;
  close: () => void;
};

export const useBookingFoundHandoffStore = create<BookingFoundHandoffStore>(set => ({
  handoff: undefined,
  open: handoff => set({handoff: {...handoff, startedAt: performance.now()}}),
  close: () => set({handoff: undefined}),
}));

export {HANDOFF_OPEN_MS};
export type {BookingFoundHandoff, FoundReservation};
